import { render, staticRenderFns } from "./root-pogs-cases.vue?vue&type=template&id=a5d7dec8&"
import script from "./root-pogs-cases.vue?vue&type=script&lang=js&"
export * from "./root-pogs-cases.vue?vue&type=script&lang=js&"
import style0 from "./root-pogs-cases.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports